import React from 'react';
import PropTypes from 'prop-types';
import { isInternalURL } from '@plone/volto/helpers';
import { Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { FormattedMessage, injectIntl } from 'react-intl';
import { UniversalLink, Image } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faBook } from '@fortawesome/free-solid-svg-icons';
import { Icon } from '../../'


const IconListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {

	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';

	return (
		<section className='directLinks'>
			<Container>
				{blockTitle && <h3 className="directLinks__title mt-0">{blockTitle}</h3>}
				<ul className="directLinks__list list-unstyled mt-0">
					{items.map((item) => (
						<li key={item['@id']} >
							<article className="directLinksItem position-relative">
								<span aria-hidden="true" className="directLinksItem__icon__wrapper">
									{item?.content_icon ? (
										<Icon name={item.content_icon} className="directLinksItem__icon" />
									) : (
										<FontAwesomeIcon icon={faBook} className="directLinksItem__icon" />
									)}
								</span>
								<h3 className="directLinksItem__title my-0">
									<UniversalLink
										className="directLinksItem__link stretched-link"						
										href={item?.getRemoteUrl ? item?.getRemoteUrl : item['@id']}>
										{item.title || item.id}
								</UniversalLink>
								</h3>										
								{item.description &&
									<p className="directLinksItem__desc mt-3 mb-0">{item.description}</p>
								} 
							</article>
						</li>
					))}
				</ul>

				{link &&
					<p className="readMoreItem mb-5 d-print-none text-center">
						<UniversalLink href={link} className="readMoreItem__btn ui button primary">
							{linkTitle ? (
								<span>{linkTitle}</span>
							) : (
								<>
									<FormattedMessage id="See all" defaultMessage="See all" />
									<span className="visually-hidden">{blockTitle}</span> 
								</>
							)}							
						</UniversalLink>
					</p>
				}
			</Container>
		</section>
	);
}

IconListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default IconListing;
